import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'm-v-v',
  templateUrl: './m-vv.component.html',
  styleUrls: ['./m-vv.component.scss']
})
export class MVVComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
